import getAccountErrorMessage from "@saleor/utils/errors/account";

export function useAccountValidation(initialForm) {
  const { firstName, lastName, contactNo } = initialForm;

  const firstNameMessage = () => {
    if (firstName === "") {
      return "This field should not be empty.";
    }

    return null;
  };

  const lastNameMessage = () => {
    if (lastName === "") {
      return "This field should not be empty.";
    }
    return null;
  };

  const contactNoMessage = () => {
    if (contactNo === "") {
      return "This field should not be empty.";
    } else if (contactNo.length < 12 || contactNo.length > 12) {
      return "Contact number should have 12 numbers.";
    }

    return null;
  };

  return {
    contactNo: contactNoMessage(),
    firstName: firstNameMessage(),
    lastName: lastNameMessage()
  };
}

export const checkError = (key, formErrors, validationError, intl) => {
  const message = formErrors[key]
    ? formErrors[key].message
    : getAccountErrorMessage(formErrors[key], intl);
  return {
    hasError: !!formErrors[key] || !!validationError[key],
    message: formErrors[key] ? message : validationError[key]
  };
};

export const hasNoError = validationError => {
  let thisReturn = true;
  Object.keys(validationError).forEach(key => {
    if (thisReturn) {
      thisReturn = validationError[key] === null;
    }
  });
  return thisReturn;
};
